import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
// import helper from './utils/helper'

//loading pages
// import LoadingPage from "./pages/LoadingPage.vue";
// import HomePage from "./pages/home.vue";
// import HomePageV5 from "./pages/homeV5.vue";
// import HomePageRed from "./pages/home/red_home.vue";
// import OthersAboutUs from "./pages/others/aboutUs.vue";
// import OthersContact from "./pages/others/contact.vue";
// import OthersTeam from "./pages/others/team.vue";
// import OthersSuccessStories from "./pages/others/successStories.vue";
// //chat
// import TimChat from "./pages/chat/tim_chat.vue";
// import ClientChat from "./pages/chat/index.vue";
// import unverifiedClientChat from "./pages/chat/unVerified.vue";
// //lead
// import LeadSteps from "./pages/lead/steps.vue"
// //free mode
// import FreeLoading from "./pages/free_mode/loading.vue"
// import FreeIndex from "./pages/free_mode/index.vue"
// import MatchPreview from "./pages/free_mode/match_preview.vue"
// import Verification from "./pages/free_mode/verification.vue"

// //onboarding
// import OnboardingSign from "./pages/onboarding/sign.vue";
// import VerifiyPending from "./pages/onboarding/verifiyPending.vue";
// import AccountPaused from "./pages/onboarding/accountPaused.vue"
// import OnboardingSms from "./pages/onboarding/smsVerify.vue";
// import OnboardingProfileSteps from "./pages/onboarding/profile-steps.vue";
// //register
// import RegSteps4 from "./pages/register/steps4.vue";
// import RegSteps3 from "./pages/register/steps3.vue";
// import RegSteps2 from "./pages/register/steps2.vue";
// import RegSteps from "./pages/register/steps.vue";
// import RegisterPhoto from "./pages/register/photo.vue";
// import RegisterPhoto6 from "./pages/register/photo6.vue";
// import RegisterProfile2 from "./pages/register/profile2.vue";
// import RegisterProfile from "./pages/register/profile.vue";
// import RegisterGetVerified from "./pages/register/getVerified.vue";
// import RegisterWelcome from "./pages/register/welcome.vue";
// import RegisterQuestionnaire from "./pages/register/questionnaire.vue";
// import RegisterMatchPreview from "./pages/register/matchPreview.vue";
// import RegisterMatchmakers from "./pages/register/matchmakers.vue";
// import RegisterhowItWorks from "./pages/register/howItWorks.vue";
// import RegisterCheckout from "./pages/register/checkout.vue";
// import CreditCard from "./pages/profile/creditCard.vue";
// //profile
// import MePage from "./pages/profile/me.vue";
// import Settings from "./pages/profile/settings.vue";
// // import EditProfile from "./pages/profile/editProfile.vue";
// import PhotoEdit from "./pages/profile/photoEdit.vue";
// import Edit2Profile from "./pages/profile/edit2.vue";
// import ViewProfile from "./pages/profile/view.vue";
// import Requirement from "./pages/profile/requirement.vue";
// import MyAccount from "./pages/profile/myAccount.vue";
// import CreditCardList from "./pages/profile/creditCardList.vue";
// //payment
// import PlansSelect from "./pages/payment/planSelect.vue";
// import FreePayment from "./pages/payment/freePayment.vue";
// import RenewPayment from "./pages/payment/renewPayment.vue";
// import Checkout from "./pages/payment/checkout.vue";
// import PaymentDeclined from "./pages/payment/paymentDeclined.vue";
// import PaymentReceipt from "./pages/payment/paymentReceiptUpload.vue";
// import PaymentSuccess from "./pages/payment/paySuccess.vue";
// import MembershipChoose from "./pages/payment/membershipChoose.vue"
// import MembershipUpgrade from "./pages/payment/membershipUpgrade.vue"
// import UpgradeCongrats from "./pages/payment/upgradeCongrats.vue"
// import SpeedDatingMembership from "./pages/payment/speedDatingMembership.vue"
// // import PlansChoose from "./pages/payment/plansChoose.vue";

// import EventTicketSelect from "./pages/payment/eventTicketSelect.vue";
// import DateCreditSelect from "./pages/payment/dateCreditSelect.vue";
// import ExtendCreditSelect from "./pages/payment/extendCreditSelect.vue";
// import LovestruckCreditSelect from "./pages/payment/lovestruckCreditSelect.vue";
// import PayMethods from "./pages/payment/payMethods.vue";
// import payFinish from "./pages/payment/payFinish.vue";
// import payFailed from "./pages/payment/payFailed.vue";
// import upgradePopup from "./pages/payment/upgradePopup.vue";
// //order
// import orderPaymentView from './pages/order/paymentView'
// //event
// import DateEventsList from "./pages/event/dateEvents.vue"
// import EventList from "./pages/event/list.vue"
// import EventInfo from "./pages/event/info.vue"
// //video
// import VideoChatRoom2 from './pages/video/chatRoom.vue'
// import VideoChatRoom from './pages/video/chatRoomTencent.vue'
//chat
// import ChatRoom from "./pages/chat-room.vue";
// import ClientChatRoom from "./pages/employee-client/client-chat-room.vue";
import Unauthorized from "./pages/unauthorized.vue";

//f7chat
import F7app from "./F7app.vue";
import F7appTim from "./F7appTim.vue";
//search
// import searchMatchList from './pages/search/matchList.vue'
// //match
// import introMatch from './pages/match/introMatches.vue'
// import newMatch from './pages/match/newMatch.vue'
// // import newMatch2 from './pages/match/newMatch2.vue'
// import MatchList from './pages/match/matchList.vue'
// import MatchUnverified from './pages/match/unverified.vue'
// import MatchClient from './pages/match/matchClient.vue'
// import MatchCard from './pages/match/matchCard.vue'
// import matchList2d from './pages/match/matchList2d.vue'
// //elites
// import EliteList from './pages/elites/eliteList.vue'
// import BookConsultation from './pages/elites/bookConsultation.vue'
// //dates
// import DateEventList from './pages/dates/dateEventList.vue'
// import DateEventInfo from './pages/dates/dateEventInfo.vue'
// import DatesList from './pages/dates/datesList.vue'
// import DateInfo from './pages/dates/dateInfo.vue'
// import ViewFeedback from './pages/dates/viewFeedback.vue'
// import GiveFeedback from './pages/dates/giveFeedback.vue'
// //single page
// import SinglePage from './pages/others/singlePage.vue'
//err
import WebError from "./pages/webError.vue";
//test
// import Test1 from "./pages/test/local.vue"
// import Touch from "./pages/test/touch.vue"
// import TestJsHander from "./pages/test/JsHandler.vue"
// import Copper from "./pages/test/copper.vue"
// import Gps from "./pages/test/gps.vue"
// import testUpload from "./pages/test/upload.vue"
//import Test2 from "./pages/test/Test2.vue"
// import jwt_decode from 'jwt-decode';
// import ApiRequest from './api/apiRequest'
// import { nesting } from "postcss-selector-parser";
// let jwt = {
//     decode: (token) => {
//         return jwt_decode(token)
//     }
// }

Vue.use(Router);

let $http = axios.create({
  baseURL: "https://api.lovestruck.com",
});

export function createRouter(store, i18n) {
  const routerNames = {
    // EMPLOYEE_CHAT: 'echat-room',
    // CLIENT_CHAT: 'client-chat-room',
    WEB_ERROR: "WebError",
    UNAUTHORIZED: "Unauthorized",
  };

  let router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior(to, from, savedPosition) {
      console.log("scrollBehavior", savedPosition);
      if (savedPosition) {
        return savedPosition;
      } else {
        return { x: 0, y: 0 };
      }
    },
    routes: [
      {
        path: "/",
        name: "loading-page",
        // component: LoadingPage,
        redirect: "/hongkong/chat",
        // component: F7appTim,
        // // component: HomePageRed,
        // meta: {
        //     auth: false
        // }
      },
      //
      // {
      //     path: "/:city/home",
      //     name: "home-v5",
      //     component: HomePageV5,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/red-home",
      //     name: "home-red",
      //     component: HomePageRed,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/home-v4",
      //     name: "home-v4",
      //     component: HomePage,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/test/touch",
      //     name: "test-touch",
      //     component: Touch,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/test/local",
      //     name: "test-test1",
      //     component: Test1,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/test/jsHander",
      //     name: "test-test2",
      //     component: TestJsHander,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/test/copper",
      //     name: "test-copper",
      //     component: Copper,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/test/gps",
      //     name: "test-gps",
      //     component: Gps,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/reg-step3",

      //     name: "reg-step3",
      //     component: RegSteps3,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/reg-step2",
      //     name: "reg-step2",
      //     component: RegSteps2,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/reg-step",
      //     name: "reg-step",
      //     component: RegSteps3,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/regStep",
      //     name: "reg-step-ss",
      //     component: RegSteps4,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/reg-step-old",

      //     name: "reg-step-old",
      //     component: RegSteps,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/about",
      //     name: "about-us",
      //     component: OthersAboutUs,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/team",
      //     name: "our-team",
      //     component: OthersTeam,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/contact",
      //     name: "contact-us",
      //     component: OthersContact,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/success-stories",
      //     name: "success-stories",
      //     component: OthersSuccessStories,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/terms",
      //     name: "terms",
      //     component: SinglePage,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/privacy",
      //     name: "privacy-policy",
      //     component: SinglePage,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/privacy-policy",
      //     name: "privacy-policy2",
      //     component: SinglePage,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/lead-steps",
      //     name: "lead-steps",
      //     component: LeadSteps,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/register/photo",
      //     name: "register-photo",
      //     component: RegisterPhoto6,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/free-home",
      //     name: "free-index",
      //     component: FreeIndex,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/free-loading",
      //     name: "free-loading",
      //     component: FreeLoading,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/match-preview",
      //     name: "match-preview",
      //     component: MatchPreview,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/verification-process",
      //     name: "client-verification",
      //     component: Verification,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/search",
      //     // redirect: '/app/:city/matches',
      //     name: "search-list",
      //     component: searchMatchList,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/chat",
      //     name: "client-chat",
      //     component: TimChat,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/web-chat",
      //     // redirect: '/:city/tim-chat',
      //     name: "client-web-chat",
      //     component: ClientChat,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/chat/matchmaker",
      //     // redirect: '/:city/tim-chat',
      //     name: "matchmaker-chat",
      //     component: TimChat,
      //     // component: ClientChat,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/chat/matchmaker-unerified",
      //     name: "matchmaker-chat-unerified",
      //     component: unverifiedClientChat,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/photo_old",
      //     name: "register-photo-old",
      //     component: RegisterPhoto,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/profile",
      //     name: "register-profile",
      //     component: RegisterProfile,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/profile2",
      //     name: "register-profile2",
      //     component: RegisterProfile2,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/getVerified",
      //     name: "register-get-verified",
      //     component: RegisterGetVerified,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/welcome",
      //     name: "register-welcome",
      //     component: RegisterWelcome,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/questionnaire",
      //     name: "register-questionnaire",
      //     component: RegisterQuestionnaire,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/match-preview",
      //     name: "register-match-preview",
      //     component: RegisterMatchPreview,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/matchmakers",
      //     name: "register-matchmakers",
      //     component: RegisterMatchmakers,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/howitworks",
      //     name: "register-howitworks",
      //     component: RegisterhowItWorks,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/checkout",
      //     name: "register-checkout",
      //     component: RegisterCheckout,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/register/credit-card",
      //     name: "register-credit-card",
      //     component: CreditCard,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile/setting",
      //     name: "profile-setting",
      //     component: Settings,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile2/edit",
      //     name: "profile2-edit",
      //     component: Edit2Profile,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/profile/photo",
      //     name: "photo-edit",
      //     component: PhotoEdit,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile/edit",
      //     name: "profile-edit",
      //     component: Edit2Profile,//EditProfile,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile/requirement",
      //     name: "profile-requirement",
      //     component: Requirement,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile/me",
      //     name: "profile-me",
      //     component: MePage,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile/myaccount",
      //     name: "profile-my-account",
      //     component: MyAccount,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile/callTime",
      //     name: "profile-call-time",
      //     component: RegisterGetVerified,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile/photo6",
      //     name: "profile-photo",
      //     component: RegisterPhoto6,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile/credit-card",
      //     name: "profile-credit-card",
      //     component: CreditCard,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile/cardlist",
      //     name: "profile-cardlist",
      //     component: CreditCardList,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/profile/:clientId",
      //     name: "profile-view",
      //     component: ViewProfile,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/match/card",
      //     name: "match-card",
      //     component: MatchCard,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/match/unverified",
      //     name: "match-unverified",
      //     component: MatchUnverified,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/match/list2d",
      //     name: "match-list2d",
      //     component: matchList2d,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/matches",
      //     name: "match-new",
      //     component: newMatch2,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/matches",
      //     name: "match-new",
      //     component: newMatch,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/intro-matches",
      //     name: "match-intro",
      //     component: introMatch,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/match/list",
      //     name: "match-list",
      //     component: MatchList,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/match/list/:matchType",
      //     name: "match-matchType",
      //     component: MatchList,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/match/clients",
      //     name: "match-client",
      //     component: MatchClient,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/elite/list",
      //     name: "elite-list",
      //     component: EliteList,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/book_consultation",
      //     name: "book-consultation",
      //     component: BookConsultation,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/date/list",
      //     name: "dates-list",
      //     component: DatesList,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/date/1-on-1",
      //     name: "date-1on1",
      //     component: DateEventList,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/date/events",
      //     name: "date-event-list",
      //     component: DateEventList,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/date/past",
      //     name: "date-past",
      //     component: DateEventList,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/date/event/:id",
      //     name: "date-event-info",
      //     component: DateEventInfo,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/date/:id",
      //     name: "dates-info",
      //     component: DateInfo,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/date/view-feedback/:id/:tag",
      //     name: "dates-view-feedback",
      //     component: ViewFeedback,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/date/give-feedback/:id",
      //     name: "dates-give-feedback",
      //     component: GiveFeedback,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/order/pay_view",
      //     name: "order-payview",
      //     component: orderPaymentView,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/order/pay_view/:id",
      //     name: "order-payviewid",
      //     component: orderPaymentView,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/video/room2/:consultation_id",
      //     name: "video-room2",
      //     component: VideoChatRoom2,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //   path: "/:city/video/room",
      //   name: "video-room",
      //   component: VideoChatRoom,
      //   meta: {
      //     auth: false
      //   }
      // },
      // {
      //     path: "/:city/payment/choice",
      //     name: "payment-choice",
      //     // component: PlansChoose,
      //     component: PlansSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //   path: "/:city/payment/diamond",
      //   name: "payment-diamond",
      //   component: PlansChoose,
      //   meta: {
      //     auth: false
      //   }
      // },
      // {
      //     path: "/:city/payment/methods",
      //     name: "payment-methods",
      //     // component: PayMethods,
      //     component: Checkout,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/membership-choose",
      //     name: "membership-choose",
      //     component: MembershipChoose,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/free",
      //     name: "free-payment",
      //     component: FreePayment,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/payment/renew",
      //     name: "renew-payment",
      //     component: RenewPayment,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/payment/membership-upgrade",
      //     name: "membership-upgrade",
      //     component: MembershipUpgrade,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/methodsold",
      //     name: "payment-methodsold",
      //     component: PayMethods,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/finish/:planName",
      //     name: "payment-finish",
      //     component: payFinish,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/failed",
      //     name: "payment-failed",
      //     component: payFailed,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/upgradePopup",
      //     name: "payment-upgrade-pop",
      //     component: upgradePopup,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/payment/plans",
      //     name: "payment-plans",
      //     component: PlansSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/checkout",
      //     name: "payment-checkout",
      //     component: Checkout,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/declined",
      //     name: "payment-declined",
      //     component: PaymentDeclined,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/receipt-upload",
      //     name: "payment-receipt",
      //     component: PaymentReceipt,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/payment/success",
      //     name: "payment-success",
      //     component: PaymentSuccess,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/upgrade-congrats",
      //     name: "upgrade-congrats",
      //     component: UpgradeCongrats,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/payment/date",
      //     redirect: '/app/:city/payment/dates'
      //     // name: "payment-date",
      //     // component: DateCreditSelect,
      //     // meta: {
      //     //     auth: false
      //     // }
      // },
      // {
      //     path: "/:city/payment/dates",
      //     name: "payment-date",
      //     component: DateCreditSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/extends",
      //     name: "payment-extend",
      //     component: ExtendCreditSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/lovestrucks",
      //     name: "payment-lovestruck",
      //     component: LovestruckCreditSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/speed-dating",
      //     name: "payment-speed-dating-basic",
      //     component: SpeedDatingMembership,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/speed-dating-gold",
      //     name: "payment-speed-dating-gold",
      //     component: SpeedDatingMembership,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/events",
      //     name: "payment-event",
      //     component: EventTicketSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/reservation",
      //     name: "payment-date2",
      //     component: DateCreditSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/gold",
      //     name: "payment-plan-gold",
      //     component: PlansSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/platinum",
      //     name: "payment-plan-platinum",
      //     component: PlansSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/diamond",
      //     name: "payment-plan-dia",
      //     component: PlansSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/payment/:planName",
      //     name: "payment-plan",
      //     component: PlansSelect,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      // 	path: "/:city/employee/chat",
      // 	name: "echat-room",
      // 	component: ChatRoom,
      // 	meta: {
      // 		auth: true
      // 	}
      // },
      // {
      // 	path: "/:city/employee/clientChat",
      // 	name: "client-chat-room",
      // 	component: ClientChatRoom,
      // 	meta: {
      // 		auth: true
      // 	}
      // },
      {
        path: "/:city/chat",
        // redirect: '/app/:city/employee/tim-chat',
        name: "employee-chat",
        component: F7app,
        meta: {
          auth: false,
        },
      },
      {
        path: "/:city/tim-chat",
        name: "employee-tim-chat",
        component: F7appTim,
        meta: {
          auth: false,
        },
      },
      //
      // {
      //     path: "/:city/event/list",
      //     name: 'event-list',
      //     component: EventList,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/events",
      //     name: 'new-event-list',
      //     component: DateEventsList,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/event/:id",
      //     name: 'event-info',
      //     component: EventInfo,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/signin",
      //     name: 'sign-in',
      //     component: OnboardingSign,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/verify-pending",
      //     name: 'verify-pending',
      //     component: VerifiyPending,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/account-paused",
      //     name: 'account-paused',
      //     component: AccountPaused,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/smsverify",
      //     name: 'sms-verify',
      //     component: OnboardingSms,
      //     meta: {
      //         auth: false
      //     }
      // },
      // {
      //     path: "/:city/profile-steps",
      //     name: 'profile-steps',
      //     component: OnboardingProfileSteps,
      //     meta: {
      //         auth: true
      //     }
      // },
      // {
      //     path: "/:city/signout",
      //     name: 'sign-out',
      //     // component: F7app,
      //     // meta: {
      //     // 	auth: false
      //     // }
      //     beforeEnter: (to, from, next) => {

      //         Vue.prototype.$storage.clearLogin();
      //         console.log('goto home 770', ncity)

      //         if (typeof location == 'undefined') {
      //             next({
      //                 name: "city-home",
      //                 params: { city: _.get(to.params, 'city', 'hong-kong') }
      //             });
      //         } else {
      //             location.href = `${location.origin}/app/${_.get(to.params, 'city', 'hong-kong')}`
      //             // location.href = `${location.origin}/app/${_.get(to.params, 'city', 'hongkong')}`
      //         }

      //         return false;
      //     }
      // },
      {
        path: "/error",
        name: "WebError",
        component: WebError,
      },
      {
        path: "/unauthorized",
        name: "Unauthorized",
        component: Unauthorized,
      },
      {
        path: "/:city",
        name: "city-home",
        component: F7appTim,
        meta: {
          auth: false,
        },
        // async: function (to, routeFrom, resolve) {
        //     (async () => {
        //         console.log('city home', to, routeFrom, resolve)
        //     })()
        // }
      },
    ],
  });

  router.beforeEach(async (to, from, next) => {
    console.log("route init", to, from);
    next();

    // switch (to.name) {
    //     // case 'city-home':
    //     //     if (!from.name) {
    //     //         if (to.params.city == 'hongkong') {
    //     //             next({
    //     //                 name: "city-home",
    //     //                 params: { city: 'hong-kong' }
    //     //             });
    //     //         } else {
    //     //             next();
    //     //         }
    //     //     } else {
    //     //         next();
    //     //     }

    //     //     break;
    //     case routerNames.WEB_ERROR:
    //     case routerNames.UNAUTHORIZED:
    //         {

    //             next();
    //             break;
    //         }
    //     default:
    //         {
    //             // console.log('to', to, next)
    //             if (to.path.indexOf('employee/chat') > -1 || to.path.indexOf('employee/tim-chat') > -1) {
    //                 // console.log('next111')
    //                 next();
    //                 // console.log('next222')
    //                 return;
    //             }
    //             // //   console.log('--- router.beforeEach')
    //             // var defautlCity = 'hong-kong';
    //             // let store_token = store.getters.token
    //             // let cur_site = {}
    //             // let foundCity = false
    //             // //console.log('store_token=', store_token)
    //             // // Vue.prototype.$storage.set('localTest', '2020.05.18')
    //             // function frontEndCheck(to) {
    //             //     let userInfo = Vue.prototype.$storage.get("userInfo")
    //             //     let user = Vue.prototype.$storage.get("user")
    //             //     // console.log('user===', user)
    //             //     // console.log(userInfo, to.name, _.includes(['loading-page', 'city-home'], to.name))

    //             //     //, 'profile-me'
    //             //     if (_.includes(['loading-page', 'city-home'], to.name) && _.get(userInfo, 'access_token', false)) {

    //             //         //window.location.href = _.get(userInfo, 'crm_link');
    //             //         // console.log('need go to crm link....')

    //             //         let ncity = _.get(to.params, 'city', defautlCity)
    //             //         console.log('goto home 842', ncity)
    //             //         let jump = helper.parseFirstLoadPage(userInfo)
    //             //         next({
    //             //             name: jump.route_name,
    //             //             params: { city: ncity },
    //             //             query: jump.query ? jump.query : {}
    //             //         })
    //             //         // location.href = `${location.origin}/${ncity}`
    //             //         // let first_load_page = _.get(userInfo, 'first_load_page', 'client_chat')
    //             //         // if (_.get(userInfo, 'membership_level_id', 0) <= 1) {
    //             //         //     next({
    //             //         //         // name: 'client-chat',
    //             //         //         name: 'free-index',
    //             //         //         params: { city: ncity }
    //             //         //     })
    //             //         // } else {
    //             //         //     next({
    //             //         //         // name: 'match-list',
    //             //         //         // name: 'elite-list',
    //             //         //         name: 'client-chat',
    //             //         //         // name: 'search-list',
    //             //         //         // name: 'match-new',
    //             //         //         params: { city: ncity }
    //             //         //     })
    //             //         // }

    //             //         return true;
    //             //     }
    //             //     if (to.query.token) {
    //             //         // console.log('replace token to empty....')
    //             //         delete to.query.token
    //             //         router.replace({ name: to.name, params: to.params, query: to.query })
    //             //         return true;
    //             //     }

    //             //     if (to.matched.some(record => record.meta.auth)) {

    //             //         let hasAuth = Vue.prototype.$storage.getAuthTag();

    //             //         // console.log('----- need auth', hasAuth, user)

    //             //         if (!user || _.get(user, 'isEmployee')) {
    //             //             // console.log('----- Unauthorized .....')
    //             //             Vue.prototype.$storage.clearLogin();
    //             //             // Vue.prototype.$storage.remove('user')
    //             //             // Vue.prototype.$storage.remove('userInfo')
    //             //             // Vue.prototype.$storage.remove('token')

    //             //             let ncity = _.get(to.params, 'city', defautlCity)
    //             //             console.log('goto home 875', ncity)

    //             //             if (typeof location == 'undefined') {
    //             //                 next({
    //             //                     name: "city-home",
    //             //                     params: { city: ncity }
    //             //                 });
    //             //             } else {
    //             //                 location.href = `${location.origin}/app/${ncity}`
    //             //                 // location.href = `${location.origin}/app/${ncity}`
    //             //             }
    //             //             return false;
    //             //         } else if (hasAuth) {
    //             //             return true;
    //             //         } else {
    //             //             ApiRequest.getIsAuth('', { token: _.get(to.query, 'token', _.get(user, 'token', false)) }, store.state)
    //             //                 .then(rs => {
    //             //                     // console.log('======getIsAuth', rs)
    //             //                     if (!rs.isAuth) {
    //             //                         Vue.prototype.$storage.clearLogin();

    //             //                         let ncity = _.get(to.params, 'city', defautlCity)
    //             //                         console.log('goto home 896', ncity)

    //             //                         if (typeof location == 'undefined') {
    //             //                             next({
    //             //                                 name: "city-home",
    //             //                                 params: { city: ncity }
    //             //                             });
    //             //                         } else {
    //             //                             location.href = `${location.origin}/app/${ncity}`
    //             //                             // location.href = `${location.origin}/app/${ncity}`
    //             //                         }
    //             //                         // next({
    //             //                         //     // name: "Unauthorized"
    //             //                         //     name: "city-home",
    //             //                         //     params: { city: ncity }
    //             //                         // });
    //             //                         return false;
    //             //                     } else {

    //             //                         Vue.prototype.$storage.setAuthTag()

    //             //                         return true;
    //             //                     }
    //             //                 })
    //             //                 .catch(err => {
    //             //                     // console.log('check auth error', err)
    //             //                     Vue.prototype.$storage.clearLogin();
    //             //                     // Vue.prototype.$storage.remove('user')
    //             //                     // Vue.prototype.$storage.remove('userInfo')
    //             //                     // Vue.prototype.$storage.remove('token')

    //             //                     let ncity = _.get(to.params, 'city', defautlCity)
    //             //                     console.log('goto home 928', ncity)

    //             //                     if (typeof location == 'undefined') {
    //             //                         next({
    //             //                             name: "city-home",
    //             //                             params: { city: ncity }
    //             //                         });
    //             //                     } else {
    //             //                         location.href = `${location.origin}/app/${ncity}`
    //             //                         // location.href = `${location.origin}/app/${ncity}`
    //             //                     }
    //             //                     // next({
    //             //                     //     // name: "Unauthorized"
    //             //                     //     name: "city-home",
    //             //                     //     params: { city: ncity }
    //             //                     // });
    //             //                     return false;
    //             //                 })

    //             //         }

    //             //     }

    //             //     return true;
    //             // }

    //             // let userOrTokenCheck = new Promise((resolve, reject) => {
    //             //     //check in front-end
    //             //     if (typeof window != 'undefined') {

    //             //         if (to.query.token && to.query.token != store_token) {
    //             //             // Vue.prototype.$layer.loading();
    //             //             let payload = jwt.decode(to.query.token);

    //             //             let now = Math.round((new Date()).getTime() / 1000);
    //             //             // console.log('payload=====', payload, now);
    //             //             if (!_.get(payload, 'clientId', false) || now > _.get(payload, 'exp', 0)) {
    //             //                 // console.log('frontEndCheck ---- to');
    //             //                 if (frontEndCheck(to)) {
    //             //                     resolve();
    //             //                 } else {
    //             //                     reject('frontEndCheck faied at token')
    //             //                 }
    //             //             }
    //             //             ApiRequest.postLoginByToken(to.query.token, store.state)
    //             //                 .then(rs => {
    //             //                     // console.log('----------getLoginByToken', rs)

    //             //                     // return false;
    //             //                     // process.exit;
    //             //                     helper.setLoginData(rs)
    //             //                     // Vue.prototype.$storage.set('user', {
    //             //                     //     id: _.get(rs, 'client_id', ''),
    //             //                     //     userId: _.get(rs, 'client_id', ''),
    //             //                     //     token: _.get(rs, 'access_token', ''),
    //             //                     //     isEmployee: false,
    //             //                     //     isCrm: true
    //             //                     // })
    //             //                     // Vue.prototype.$storage.set('userInfo', rs)
    //             //                     // Vue.prototype.$storage.set('token', _.get(rs, 'access_token', ''))
    //             //                     // Vue.prototype.$storage.setAuthTag();
    //             //                     store.commit('SET_TOKEN', _.get(rs, 'access_token', ''))
    //             //                     store.commit('SET_CUR_LANG', { curlang: _.get(rs, 'lang_code', '') })

    //             //                     if (frontEndCheck(to)) {
    //             //                         resolve();
    //             //                     } else {
    //             //                         reject('frontEndCheck faied at token login')
    //             //                     }
    //             //                 })
    //             //                 .catch(err => {
    //             //                     // console.log('--------getLoginByToken err', err)
    //             //                     //next({name:'WebError'})
    //             //                     //return;
    //             //                     Vue.prototype.$storage.remove('user');
    //             //                     Vue.prototype.$storage.remove('userInfo');
    //             //                     Vue.prototype.$storage.remove('token');

    //             //                     if (frontEndCheck(to)) {
    //             //                         // console.log('--catch--frontEndCheck')
    //             //                         resolve();
    //             //                     } else {
    //             //                         reject('frontEndCheck faied at token login error')
    //             //                     }
    //             //                 })
    //             //         } else {
    //             //             // console.log('--no-token')
    //             //             if (frontEndCheck(to)) {
    //             //                 // console.log('--no-token--resolve')
    //             //                 resolve();
    //             //             } else {
    //             //                 reject('frontEndCheck faied at no-token')
    //             //             }
    //             //         }
    //             //     } else {
    //             //         // console.log('--no-window--resolve')
    //             //         resolve();
    //             //     }

    //             // });

    //             // userOrTokenCheck.then(() => {
    //             //     // console.log('--FETCH_SITE_DATA--2020')
    //             //     return store.dispatch('FETCH_SITE_DATA')
    //             // })
    //             //     .then((storeRes) => {
    //             //         let cities = store.getters.cities

    //             //         foundCity = _.get(cities, _.get(to, 'params.city'), false)

    //             //         // console.log('---store.dispatch-----FETCH_SITE_DATA', _.get(to, 'params.city'), foundCity, to.name)

    //             //         if (to.name == 'loading-page' || !foundCity) {
    //             //             // console.log('--- FETCH_IP_CITY begin')
    //             //             return store.dispatch('FETCH_IP_CITY')
    //             //         } else if (to.name == 'city-home' && !foundCity) {
    //             //             return store.dispatch('FETCH_IP_CITY')
    //             //         } else {
    //             //             // console.log('--- has city', to.params.city)
    //             //             let sites = store.getters.sites
    //             //             let cities = store.getters.cities
    //             //             let url_city = to.params.city;
    //             //             //let store_city = store.getters.curCity;

    //             //             if (url_city && cities[url_city]) {
    //             //                 cur_site = _.get(sites, cities[url_city]['index'], false)

    //             //                 if (!cur_site) {
    //             //                     // console.log('not found site by url city', url_city)
    //             //                     next({ name: 'WebError' })
    //             //                     return;
    //             //                 }

    //             //                 store.commit('SET_CUR_CITY', { curcity: url_city })
    //             //                 store.commit('SET_CUR_SITE', { cursite: cur_site })
    //             //                 // console.log('===url_city', url_city, '====', cur_site)
    //             //                 return Promise.resolve({ "success": true });
    //             //             } else {
    //             //                 //go to default city
    //             //                 // console.log('go to default city 000');
    //             //                 console.log('goto home 1069', defautlCity)

    //             //                 // next({ name: 'city-home', params: { city: defautlCity } })
    //             //                 if (typeof location == 'undefined') {
    //             //                     next({
    //             //                         name: "city-home",
    //             //                         params: { city: defautlCity }
    //             //                     });
    //             //                 } else {
    //             //                     location.href = `${location.origin}/app/${defautlCity}`
    //             //                     // location.href = `${location.origin}/app/${defautlCity}`
    //             //                 }
    //             //                 return;
    //             //             }
    //             //         }
    //             //     })
    //             //     .then((rs) => {
    //             //         // console.log('=====step 3333', rs);
    //             //         let ipCity = store.getters.ipCity;
    //             //         // if (to.name == 'loading-page' ||  !foundCity) {
    //             //         if (ipCity && ipCity != 'undefined' && !foundCity) {
    //             //             // console.log('--- FETCH_IP_CITY end')
    //             //             // next({ name: 'city-home', params: { city: ipCity } })
    //             //             console.log('goto home 1091', ipCity)

    //             //             if (typeof location == 'undefined') {
    //             //                 console.log('city-home not foundCity')
    //             //                 next({
    //             //                     name: "city-home",
    //             //                     params: { city: ipCity }
    //             //                 });
    //             //             } else {
    //             //                 location.href = `${location.origin}/app/${ipCity}`
    //             //                 // location.href = `${location.origin}/app/${ipCity}`
    //             //             }
    //             //             return;
    //             //             // if (ipCity && ipCity != 'undefined') {
    //             //             // 	next({ name: 'city-home', params: { city: ipCity } })
    //             //             // } else {
    //             //             // 	//go to default city
    //             //             // 	// console.log('go to default city 111');
    //             //             // 	next({ name: 'city-home', params: { city: defautlCity } })
    //             //             // 	return;
    //             //             // }
    //             //         } else if ((!ipCity || ipCity == 'undefined') && !foundCity) {
    //             //             // next({ name: 'city-home', params: { city: defautlCity } })
    //             //             console.log('goto home 1112', defautlCity)

    //             //             if (typeof location == 'undefined') {
    //             //                 next({
    //             //                     name: "city-home",
    //             //                     params: { city: defautlCity }
    //             //                 });
    //             //             } else {
    //             //                 location.href = `${location.origin}/app/${defautlCity}`
    //             //                 // location.href = `${location.origin}/app/${defautlCity}`
    //             //             }
    //             //             return;
    //             //         } else {
    //             //             // console.log('--- set lang')
    //             //             let isviewed = Vue.prototype.$storage.get('isviewed')
    //             //             let lang = cur_site.lang_default;
    //             //             let store_lang = store.getters.curLang
    //             //             let user_lang = _.get(Vue.prototype.$storage.get('userInfo'), 'lang_code', false);

    //             //             if (to.query.lang && user_lang != to.query.lang) {
    //             //                 lang = to.query.lang;
    //             //             } else if (user_lang) {
    //             //                 lang = user_lang;
    //             //             } else if (store_lang && isviewed) {
    //             //                 lang = store_lang;
    //             //             }

    //             //             // if (!_.find(cur_site.langs, { 'lang_code': lang })) {
    //             //             //     lang = cur_site.lang_default;
    //             //             // }
    //             //             if (_.indexOf(['en_us', 'zh_cn', 'zh_hk', 'th'], lang.toLowerCase()) == -1) {
    //             //                 lang = cur_site.lang_default;
    //             //             }
    //             //             // console.log('langs:', lang, cur_site.lang_default, store_lang, to.query.lang, user_lang)
    //             //             store.commit('SET_CUR_LANG', { curlang: lang })
    //             //             Vue.prototype.$storage.set('cur-lang', lang)
    //             //             Vue.prototype.$storage.set('isviewed', 1)

    //             //             return store.dispatch('FETCH_TRANSLATION_DATA')
    //             //         }
    //             //     })
    //             //     .then(() => {
    //             //         // console.log('loaded translation')

    //             //         let messages = store.getters.translation
    //             //         // console.log('messages--', messages)

    //             //         i18n.setLocaleMessage('en_US', _.get(messages, 'en_us'))
    //             //         i18n.setLocaleMessage('zh_CN', _.get(messages, 'zh_cn'))
    //             //         i18n.setLocaleMessage('zh_HK', _.get(messages, 'zh_hk'))
    //             //         i18n.setLocaleMessage('th', _.get(messages, 'th'))

    //             //         // console.log('-----store.getters.curLang', store.getters.curLang)
    //             //         i18n.locale = store.getters.curLang;

    //             //         next();
    //             //     })
    //             //     .catch(err => {
    //             //         // if (typeof window != 'undefined') {
    //             //         // 	Vue.prototype.$layer.closeAll('loading');
    //             //         // }
    //             //         // console.log('error002', err)
    //             //         // next({ name: 'WebError' })
    //             //         Vue.prototype.$storage.clearLogin();
    //             //         console.log('goto home 1175', defautlCity)

    //             //         // next({ name: 'city-home', params: { city: defautlCity } })
    //             //         if (typeof location == 'undefined') {
    //             //             next({
    //             //                 name: "city-home",
    //             //                 params: { city: defautlCity }
    //             //             });
    //             //         } else {
    //             //             location.href = `${location.origin}/app/${defautlCity}`
    //             //             // location.href = `${location.origin}/app/${defautlCity}`
    //             //         }
    //             //     });

    //             break;
    //         }

    // }
  });

  return router;
}
